import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getPublicProjectHistoryRequest: ['payload'],
    getPublicProjectHistorySuccess: ['response'],
    getPublicProjectHistoryFailure: ['error'],
})

export const getPublicProjectHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getPublicProjectHistoryRequest = state => state.merge({ success: null })

const getPublicProjectHistorySuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const getPublicProjectHistoryFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_PUBLIC_PROJECT_HISTORY_REQUEST]: getPublicProjectHistoryRequest,
    [Types.GET_PUBLIC_PROJECT_HISTORY_SUCCESS]: getPublicProjectHistorySuccess,
    [Types.GET_PUBLIC_PROJECT_HISTORY_FAILURE]: getPublicProjectHistoryFailure,
})
